import {
  PriceTemplateInterface,
  PriceTemplateRangeInterface,
  PriceTemplateRuleInterface,
  PriceTemplateSellPriceAndStrikeThroughPriceInterface,
} from '../../../../core/interfaces/price-template/price-template';

export class PriceTemplateClass implements PriceTemplateInterface {
  CreatedOn = undefined;
  Id = '';
  IsUseStrikeThroughPrice = false;
  MarketplaceIdentity = 0;
  ModifiedOn = undefined;
  ProviderId = '';
  Rules: PriceTemplateRuleInterface[] = [];
  SellPrice: PriceTemplateSellPriceAndStrikeThroughPriceInterface = {
    ChangeAmount: 0,
    IncreaseDecreaseType: 0,
    Source: 0,
    IsPercent: false,
  };
  StrikeThroughPrice: PriceTemplateSellPriceAndStrikeThroughPriceInterface = {
    ChangeAmount: 0,
    IncreaseDecreaseType: 0,
    IsPercent: false,
    Source: 0,
  };
  Title = '';
}

export class PriceTemplateRulesClass implements PriceTemplateRuleInterface {
  DirectAmount = 0;
  IsConditional = false;
  IsPercent = false;
  Ranges: PriceTemplateRangeInterface[] = [];
  Sort = 0;
  Title = '';
}

export class PriceTemplateRangeClass implements PriceTemplateRangeInterface {
  MinAmount = 0;
  MaxAmount = 0;
  ChangeAmount = 0;
}
